module.exports = __webpack_public_path__ + "static/media/1.21.f3771669.png";